export class Meta {
  // 调试ID
  id: number = Math.random();

  // 类型: FORM | string
  type: string = undefined;

  auto_unbox: boolean | string[] = undefined;

  // 当前自定义的并且需要给组件透传的属性
  properties = new Set<string>();

  // 当前自定义的并且需要给组件透传的事件名
  handlers = new Set<string>();

  transformers = new Set<string>();

  definition: Record<string, any>;
}
